<template>
  <Fragment>
<!-- empty -->
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  components: {
    Fragment,
  },
};
</script>
